<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Export nou</p>
            <button type="button" class="delete" @click="$emit('close')" />
        </header>
        <section class="modal-card-body">
            <div class="columns">
                <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
                <div class="column is-12">
                    <b-tabs v-model="exportBy">
                        <b-tab-item value="byNumber" label="Dupa numar" icon="numeric">
                            <b-field :disabled="byNumber.all" :label="`${formsCount} formulare disponibile`">
                                <b-numberinput
                                    :disabled="byNumber.all"
                                    :value="byNumber.number"
                                    min="1"
                                    :max="formsCount"
                                    v-model="byNumber.number"
                                ></b-numberinput>
                            </b-field>
                            <div class="divider">Sau</div>
                            <b-switch v-model="byNumber.all">Exporta toate formularele</b-switch>
                        </b-tab-item>
                        <!-- <b-tab-item value="byDimensions" label="Dupa dimensiune" icon="image-size-select-small">
                            <b-field :disabled="byNumber.all" label="Dimensiune maxim arhiva (in MB)">
                                <b-numberinput
                                    :value="byDimensions.size"
                                    min="1"
                                    v-model="byDimensions.size"
                                ></b-numberinput>
                            </b-field>
                        </b-tab-item> -->
                    </b-tabs>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
            <b-button @click="generateExport" type="is-primary" icon-left="cogs" class="export-bt">
                Genereaza
            </b-button>
        </footer>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import * as toast from '@/utils/toast';
import { mapGetters } from 'vuex';

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({
        exportBy: 'byNumber',
        isLoading: false,
        byNumber: {
            number: 100,
            all: false,
        },
        byDimensions: {
            size: 10,
        },
        formsCount: 0,
    }),
    methods: {
        async getFormsCount() {
            this.isLoading = true;
            try {
                this.formsCount = await this.$store.dispatch('exports/GetFormsCount');
                if (this.formsCount == 0) {
                    return toast.error('Nu exista formulare disponibile pentru export.'), this.$emit('close');
                }
            } catch (err) {
                return false;
            } finally {
                this.isLoading = false;
            }
        },
        async generateExport() {
            if (!this.validateSettings()) return false;
            this.isLoading = true;
            const params = {
                exportBy: this.exportBy,
                byNumber: this.byNumber,
                byDimensions: this.byDimensions,
            };

            try {
                await this.$store.dispatch('exports/GenerateExport', params);
                toast.info('Exportul se genereaza si poate dura in functie de numarul de formulare selectat');

                return this.$emit('close');
            } catch (err) {
                console.log(err);
            } finally {
                this.isLoading = false;
            }
        },
        validateSettings() {
            if (this.exportBy === 'byNumber') {
                if (this.byNumber.all == false && this.byNumber.number <= 0) {
                    return toast.error('Numarul de formulare nu poate fi 0 sau negativ.'), false;
                }
            }
            if (this.exportBy === 'byDimensions') {
                if (this.byDimensions.size <= 0) {
                    return toast.error('Dimensiunea fisierului nu poate fi 0 sau negativa.'), false;
                }
            }
            return true;
        },
    },
    computed: {},
    async created() {
        try {
            await this.getFormsCount();
        } catch (err) {
            return false;
        }
    },
};
</script>

<style lang="scss"></style>
